'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _aboutus = require('./aboutus');

Object.keys(_aboutus).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _aboutus[key];
    }
  });
});

var _affiliate_api = require('./affiliate_api');

Object.keys(_affiliate_api).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _affiliate_api[key];
    }
  });
});

var _careers = require('./careers');

Object.keys(_careers).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _careers[key];
    }
  });
});

var _certificates = require('./certificates');

Object.keys(_certificates).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _certificates[key];
    }
  });
});

var _channels = require('./channels');

Object.keys(_channels).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _channels[key];
    }
  });
});

var _footer = require('./footer');

Object.keys(_footer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _footer[key];
    }
  });
});

var _gifts = require('./gifts');

Object.keys(_gifts).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _gifts[key];
    }
  });
});

var _home = require('./home');

Object.keys(_home).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _home[key];
    }
  });
});

var _how_it_work = require('./how_it_work');

Object.keys(_how_it_work).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _how_it_work[key];
    }
  });
});

var _menu = require('./menu');

Object.keys(_menu).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _menu[key];
    }
  });
});

var _notfound = require('./notfound');

Object.keys(_notfound).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _notfound[key];
    }
  });
});

var _subscription = require('./subscription');

Object.keys(_subscription).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _subscription[key];
    }
  });
});

var _teachers = require('./teachers');

Object.keys(_teachers).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _teachers[key];
    }
  });
});

var _wipModal = require('./wipModal');

Object.keys(_wipModal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _wipModal[key];
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ../i18n/lib/en/index.js
// module id = 708
// module chunks = 0